import { useCheckPermissions } from '@/shared';
import { SaveCostos } from '../../shared/saveCostos';
import { PermissionsEnum } from '@/auth/interfaces';

export type CreateCostosPageProps = {};

const CreateCostosPage: React.FC<CreateCostosPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_costo)
  return <SaveCostos titlePage="Crear Costos" />;
};

export default CreateCostosPage;
